export const facebookMessageConfirmOrderInitialState = {
  pages: {
    list: [],
    loading: true,
  },
  productPrintSettings: {
    settings: [],
    loading: false,
  },
  modal: {confirmStatus: {data: null, open: false}},
  detail: {
    samples:[
      {
        "type": "paragraph",
        "children": [
          {
            "text": "Đơn hàng của quý khách "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{Họ và Tên}"
              }
            ]
          },
          {
            "text": " đã được đặt hàng thành công. Mã đơn hàng là: "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{Mã đơn hàng}"
              }
            ]
          },
          {
            "text": ", mã vận đơn "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{Mã vận đơn}"
              },

            ]
          },
          {
            "text": " và link tra cứu hành trình "
          },
          {
            "type": "tag",
            "children": [
              {
                "text": "{Hyperlink tra cứu hành trình}"
              },

            ]
          },
          {
            "text": " "
          },
        ]
      },
    ],
    content_message: [ {
      "type": "paragraph",
      "children": [
        {
          "text": "Đơn hàng của quý khách "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{Họ và Tên}"
            }
          ]
        },
        {
          "text": " đã được đặt hàng thành công. Mã đơn hàng là: "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{Mã đơn hàng}"
            }
          ]
        },
        {
          "text": ", mã vận đơn "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{Mã vận đơn}"
            },

          ]
        },
        {
          "text": " và link tra cứu hành trình "
        },
        {
          "type": "tag",
          "children": [
            {
              "text": "{Hyperlink tra cứu hành trình}"
            },

          ]
        },
        {
          "text": " "
        },
      ]
    },],
    reset: false,
    status: 1,
    list:[
      {id: 1, name:'Họ và Tên'},
      {id: 2, name:'Số điện thoại'},
      {id: 3, name:'Địa chỉ'},
      {id: 4, name:'Tên trang'},
      {id: 5, name:'Mã đơn hàng'},
      {id: 6, name:'Mã vận đơn'},
      {id: 7, name:'Hyperlink tra cứu hành trình'},
    ],
    validate:''
  }
}
